const BookIcon = ({ className, onClick, width = 16, height = 16 }) => (
  <svg
    width={width}
    className={className}
    onClick={onClick}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="23" r="20" fill="#CEFBFA" />
    <path
      d="M35.333 19.167V3.333c-1.847.924-3.308 1.899-5.013 2.305-.462.11-.693.165-1.19.226-.496.06-1.04.067-2.126.08-1.787.02-4.347-.111-6.364-.111-4.974 0-7.461 0-9.208 1.26a6.666 6.666 0 00-1.504 1.505c-1.261 1.747-1.261 4.234-1.261 9.208V32.5A3.333 3.333 0 0112 29.167h13.333c3.107 0 4.66 0 5.885-.508a6.667 6.667 0 003.608-3.607c.507-1.226.507-2.779.507-5.885z"
      fill="#fff"
    />
    <path
      d="M35.333 36.667h-22.5A4.167 4.167 0 018.667 32.5m0 0V17.806c0-4.974 0-7.461 1.26-9.208a6.666 6.666 0 011.505-1.504c1.747-1.261 4.234-1.261 9.208-1.261 2.017 0 4.577.131 6.364.11 1.087-.012 1.63-.018 2.127-.08.496-.06.727-.115 1.189-.225 1.705-.406 3.166-1.38 5.013-2.305v15.834c0 3.106 0 4.66-.507 5.884a6.667 6.667 0 01-3.608 3.609c-1.225.507-2.778.507-5.885.507H12A3.333 3.333 0 008.667 32.5z"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M32 28.333v8.334" stroke="#000" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M15.334 6.667v6.666" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default BookIcon;
